import { getRequestHeaders, handleRes } from "utils";
import {
  AccessLogEntry,
  EntityTypes,
  EntityUnion,
  RevisionQueueMessage,
} from "types";

export interface GetRevisionsResponse<T extends EntityUnion> extends Response {
  revisions?: Array<RevisionQueueMessage<T>>;
}

export interface GetAccessLogsResponse extends Response {
  logs?: Array<AccessLogEntry>;
}

export const getRevisions = <T extends EntityUnion>(
  entityType: EntityTypes,
  entityID: string,
): Promise<RevisionQueueMessage<T>[]> => {
  return fetch(
    `${window.REVISION_BASE_URL}/revision/${entityType}/${entityID}`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<RevisionQueueMessage<T>[]>(res, 200))
    .catch((e) => {
      return [];
    });
};

export const getEntityAccessLogs = async (
  entityType: EntityTypes,
  entityID: string | number,
): Promise<GetAccessLogsResponse> => {
  return await fetch(
    `${window.REVISION_BASE_URL}/entityLog/${entityType}/${entityID}`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  );
};

export const getUserAccessLogs = async (
  tenantID: string | number,
  userID: string | number,
): Promise<GetAccessLogsResponse> => {
  return await fetch(
    `${window.REVISION_BASE_URL}/userLog/${tenantID}/${userID}`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  );
};

export const getTenantAccessLogs = async (
  tenantID: string | number,
): Promise<GetAccessLogsResponse> => {
  return await fetch(`${window.REVISION_BASE_URL}/tenantLog/${tenantID}`, {
    method: "GET",
    ...getRequestHeaders(),
  });
};
